import React from "react";
import { useTranslation } from "react-i18next";
import { Tag } from "primereact/tag";
import { UiTagProps } from "../../models/components/tag.model";
import { ObjectUtils } from "primereact/utils";

const UiTag = (props: UiTagProps) => {
	const { t } = useTranslation("common");

	// Handle custom purple severity
	const isPurple = props.severity === "purple";
	const isDefault = props.severity === "default";

	// PrimeReact Tag only accepts: 'success' | 'info' | 'warning' | 'danger'
	// For purple and default, we don't pass severity to PrimeReact Tag
	const tagSeverity =
		isPurple || isDefault
			? undefined
			: (props.severity as "success" | "info" | "warning" | "danger");

	// Extract className separately before using findDiffKeys
	const existingClassName = props.className || "";

	const otherProps = ObjectUtils.findDiffKeys(props, {
		value: props.value,
		uppercase: props.uppercase?.toString(),
		severity: props.severity,
		className: props.className,
	});

	const className = isPurple
		? `${existingClassName} p-tag-purple`.trim()
		: isDefault
			? `${existingClassName} p-tag-default`.trim()
			: existingClassName;

	return (
		<>
			{props.value && (
				<Tag
					value={props.uppercase ? t(props.value).toUpperCase() : t(props.value)}
					severity={tagSeverity}
					className={className}
					{...otherProps}
				></Tag>
			)}
		</>
	);
};

export default UiTag;
